import type { Associate } from '../../types/associates';
import { ClientAssociate } from '../../types/earnings';
import { CreditCard, RefreshCcw, Clock, FileText } from 'lucide-react';

import {
  AssociatesIcon,
  CallsIcon,
  ChatsIcon,
  ClientsIcon,
  DashboardIcon,
  EarningsIcon,
  OffersIcon,
  ReviewsIcon,
  WorkStreamsIcon,
} from './Icon';
import { BillingPlan } from '../../types/billing';
import { PlanKey, PricingPlan } from '../../types/plans';

export const sidebarData = [
  {
    title: 'Dashboard',
    path: '/dashboard',
    icon: <DashboardIcon fill="#6B7280" />,
    sec: <DashboardIcon fill="#FF6646" />,
    hover: <DashboardIcon fill="#FF6646" />,
  },
  {
    title: 'Talents',
    path: '/agency-talents',
    icon: <AssociatesIcon fill="#6B7280" />,
    sec: <AssociatesIcon fill="#FF6646" />,
    hover: <AssociatesIcon fill="#FF6646" />,
  },
  {
    title: 'Work Offers',
    path: '/work-offers',
    icon: <OffersIcon fill="#6B7280" />,
    sec: <OffersIcon fill="#FF6646" />,
    hover: <OffersIcon fill="#FF6646" />,
  },
  {
    title: 'Work Streams',
    path: '/work-streams',
    icon: <WorkStreamsIcon fill="#6B7280" />,
    sec: <WorkStreamsIcon fill="#FF6646" />,
    hover: <WorkStreamsIcon fill="#FF6646" />,
  },
  {
    title: 'Reviews',
    path: '/reviews',
    icon: <ReviewsIcon fill="#6B7280" />,
    sec: <ReviewsIcon fill="#FF6646" />,
    hover: <ReviewsIcon fill="#FF6646" />,
  },
  {
    title: 'Earnings',
    path: '/earnings',
    icon: <EarningsIcon fill="#6B7280" />,
    sec: <EarningsIcon fill="#FF6646" />,
    hover: <EarningsIcon fill="#FF6646" />,
  },
  {
    title: 'Clients',
    path: '/clients',
    icon: <ClientsIcon fill="#6B7280" />,
    sec: <ClientsIcon fill="#FF6646" />,
    hover: <ClientsIcon fill="#FF6646" />,
  },
  {
    title: 'My Calls',
    path: '/calls',
    icon: <CallsIcon fill="#6B7280" />,
    sec: <CallsIcon fill="#FF6646" />,
    hover: <CallsIcon fill="#FF6646" />,
  },
  {
    title: 'Chats',
    path: '/chats',
    icon: <ChatsIcon fill="#6B7280" />,
    sec: <ChatsIcon fill="#FF6646" />,
    hover: <ChatsIcon fill="#FF6646" />,
  },
];

// In your constants.ts file
const getCurrentMonthShort = () => {
  return new Date().toLocaleString('en-US', { month: 'short' });
};


export const metricsData = [
  {
    title: 'Active Contracts',
    value: '0',
    subtitle: '',
    change: {
      value: '0%',
      type: 'increase',
      period: 'from last month',
    },
    status: null,
  },
  {
    title: 'Pending Approval',
    value: '0 day',
    subtitle: `(for ${getCurrentMonthShort()})`, 
    change: null,
    status: {
      text: 'Awaiting',
      type: 'warning',
    },
  },
  {
    title: 'Approved Days',
    value: '0 days',
    subtitle: `(for ${getCurrentMonthShort()})`, 
    change: {
      value: '0%',
      type: 'increase',
      period: 'from last week',
    },
    status: null,
  },
  {
    title: 'Monthly Earnings',
    value: '$0',
    subtitle: `(in ${getCurrentMonthShort()})`, 
    change: {
      value: '0%',
      type: 'decrease',
      period: 'from last month',
    },
    status: null,
  },
  {
    title: 'Agency Rating',
    value: '0 / 5',
    subtitle: '',
    change: null,
    status: {
      text: 'Based on client',
      type: 'rating',
    },
  },
];


// export const metricsData = [
//   {
//     title: 'Active Contracts',
//     value: '70',
//     subtitle: '',
//     change: {
//       value: '12%',
//       type: 'increase',
//       period: 'from last month',
//     },
//     status: null,
//   },
//   {
//     title: 'Pending Approval',
//     value: '1 day',
//     subtitle: '(for Jul)',
//     change: null,
//     status: {
//       text: 'Awaiting',
//       type: 'warning',
//     },
//   },
//   {
//     title: 'Approved Days',
//     value: '2 days',
//     subtitle: '(for Jul)',
//     change: {
//       value: '8%',
//       type: 'increase',
//       period: 'from last week',
//     },
//     status: null,
//   },
//   {
//     title: 'Monthly Earnings',
//     value: '$666.67',
//     subtitle: '(in Jul)',
//     change: {
//       value: '3%',
//       type: 'decrease',
//       period: 'from last month',
//     },
//     status: null,
//   },
//   {
//     title: 'Agency Rating',
//     value: '4.5 / 5',
//     subtitle: '',
//     change: null,
//     status: {
//       text: 'Based on client',
//       type: 'rating',
//     },
//   },
// ];

export const companyTypeOptions = [
  { value: 'llc', label: 'Limited Liability Company (LLC)' },
  { value: 'corporation', label: 'Corporation' },
  { value: 'partnership', label: 'Partnership' },
  { value: 'sole_proprietorship', label: 'Sole Proprietorship' },
  { value: 'nonprofit', label: 'Nonprofit Organization' },
  { value: 'educational_institution', label: 'Educational Institution' },
  { value: 'government_institution', label: 'Government Institution' },
  { value: 'others', label: 'Others' },

];

export const industriesOptions = [
  { value: 'technology', label: 'Technology' },
  { value: 'healthcare', label: 'Healthcare' },
  { value: 'finance', label: 'Finance & Banking' },
  { value: 'retail', label: 'Retail & E-commerce' },
  { value: 'manufacturing', label: 'Manufacturing' },
  { value: 'education', label: 'Education' },
  { value: 'real-estate', label: 'Real Estate' },
  { value: 'automotive', label: 'Automotive' },
  { value: 'food-beverage', label: 'Food & Beverage' },
  { value: 'entertainment', label: 'Entertainment & Media' },
  { value: 'non-profit', label: 'Non-Profit' },
  { value: 'government', label: 'Government' },
  { value: 'other', label: 'Other' },
];

export const servicesOptions = [
  { value: 'web-development', label: 'Web Development' },
  { value: 'mobile-development', label: 'Mobile App Development' },
  { value: 'digital-marketing', label: 'Digital Marketing' },
  { value: 'seo', label: 'SEO Services' },
  { value: 'social-media', label: 'Social Media Management' },
  { value: 'content-creation', label: 'Content Creation' },
  { value: 'branding', label: 'Branding & Design' },
  { value: 'consulting', label: 'Business Consulting' },
  { value: 'data-analytics', label: 'Data Analytics' },
  { value: 'cloud-services', label: 'Cloud Services' },
  { value: 'cybersecurity', label: 'Cybersecurity' },
  { value: 'other', label: 'Other' },
];

// export const employeeRangeOptions = [
//   { value: '10', label: '10 employees' },
//   { value: '20', label: '20 employees' },
//   { value: '30', label: '30 employees' },
//   { value: '40', label: '40 employees' },
//   { value: '50', label: '50 employees' },
//   { value: '75', label: '75 employees' },
//   { value: '100', label: '100 employees' },
//   { value: '150', label: '150 employees' },
//   { value: '200', label: '200 employees' },
//   { value: '300', label: '300 employees' },
//   { value: '400', label: '400 employees' },
//   { value: '500', label: '500 employees' },
//   { value: '1000', label: '1000+ employees' },
// ];

export const employeeRangeOptions = [
  { value: '1', label: '0-1 employees' },
  { value: '10', label: '2-10 employees' },
  { value: '50', label: '11-50 employees' },
  { value: '200', label: '51-200 employees' },
  { value: '500', label: '201-500 employees' },
  { value: '1000', label: '501-1,000 employees' },
  { value: '5000', label: '1,001-5,000 employees' },
  { value: '10000', label: '5,001-10,000 employees' },
  { value: '10001', label: '10,001+ employees' },
];


export const genderOptions = [
  { value: 'MALE', label: 'Male' },
  { value: 'FEMALE', label: 'Female' },
  { value: 'OTHERS', label: 'Other' },
];

export const earningsTab = ['Earnings', 'Transactions'];

export const earningsData: ClientAssociate[] = [];

// export const earningsData: ClientAssociate[] = [
//   {
//     id: 'tc2024-001',
//     clientName: 'TechCorp Inc.',
//     contractId: 'TC2024-001',
//     talentName: 'Sarah Johnson',
//     talentId: 'SJ8921',
//     profileImage: '/path/to/image.jpg',
//     pay: {
//       amount: 2300,
//       period: 'month',
//       duration: '12 months',
//     },
//     earned: 9200,
//     pending: 2300,
//     status: 'In Progress',
//     monthlyBreakdown: [
//       {
//         month: 'May 2023',
//         totalPayable: 2300,
//         earned: 1150,
//         pending: 1150,
//       },
//       {
//         month: 'April 2023',
//         totalPayable: 2300,
//         earned: 2300,
//         pending: 0,
//       },
//       {
//         month: 'March 2023',
//         totalPayable: 2300,
//         earned: 2300,
//         pending: 0,
//       },
//     ],
//   },
//   {
//     id: 'tc2024-002',
//     clientName: 'TechCorp Inc.',
//     contractId: 'TC2024-001',
//     talentName: 'Sarah Johnson',
//     talentId: 'SJ8921',
//     profileImage: '/path/to/image.jpg',
//     pay: {
//       amount: 2300,
//       period: 'month',
//       duration: '12 months',
//     },
//     earned: 9200,
//     pending: 2300,
//     status: 'Closed',
//     monthlyBreakdown: [
//       {
//         month: 'May 2023',
//         totalPayable: 2300,
//         earned: 2300,
//         pending: 0,
//       },
//     ],
//   },
//   {
//     id: 'tc2024-003',
//     clientName: 'TechCorp Inc.',
//     contractId: 'TC2024-001',
//     talentName: 'Sarah Johnson',
//     talentId: 'SJ8921',
//     profileImage: '/path/to/image.jpg',
//     pay: {
//       amount: 2300,
//       period: 'month',
//       duration: '12 months',
//     },
//     earned: 9200,
//     pending: 2300,
//     status: 'Terminated',
//     monthlyBreakdown: [],
//   },
//   {
//     id: 'tc2024-004',
//     clientName: 'TechCorp Inc.',
//     contractId: 'TC2024-001',
//     talentName: 'Sarah Johnson',
//     talentId: 'SJ8921',
//     profileImage: '/path/to/image.jpg',
//     pay: {
//       amount: 2300,
//       period: 'month',
//       duration: '12 months',
//     },
//     earned: 9200,
//     pending: 2300,
//     status: 'In Notice',
//     monthlyBreakdown: [],
//   },
//   {
//     id: 'tc2024-005',
//     clientName: 'TechCorp Inc.',
//     contractId: 'TC2024-001',
//     talentName: 'Sarah Johnson',
//     talentId: 'SJ8921',
//     profileImage: '/path/to/image.jpg',
//     pay: {
//       amount: 2300,
//       period: 'month',
//       duration: '12 months',
//     },
//     earned: 9200,
//     pending: 2300,
//     status: 'In Progress',
//     monthlyBreakdown: [],
//   },
//   {
//     id: 'tc2024-006',
//     clientName: 'TechCorp Inc.',
//     contractId: 'TC2024-001',
//     talentName: 'Sarah Johnson',
//     talentId: 'SJ8921',
//     profileImage: '/path/to/image.jpg',
//     pay: {
//       amount: 2300,
//       period: 'month',
//       duration: '12 months',
//     },
//     earned: 9200,
//     pending: 2300,
//     status: 'In Progress',
//     monthlyBreakdown: [],
//   },
//   {
//     id: 'tc2024-007',
//     clientName: 'TechCorp Inc.',
//     contractId: 'TC2024-001',
//     talentName: 'Sarah Johnson',
//     talentId: 'SJ8921',
//     profileImage: '/path/to/image.jpg',
//     pay: {
//       amount: 2300,
//       period: 'month',
//       duration: '12 months',
//     },
//     earned: 9200,
//     pending: 2300,
//     status: 'In Progress',
//     monthlyBreakdown: [],
//   },
//   {
//     id: 'tc2024-008',
//     clientName: 'TechCorp Inc.',
//     contractId: 'TC2024-001',
//     talentName: 'Sarah Johnson',
//     talentId: 'SJ8921',
//     profileImage: '/path/to/image.jpg',
//     pay: {
//       amount: 2300,
//       period: 'month',
//       duration: '12 months',
//     },
//     earned: 9200,
//     pending: 2300,
//     status: 'In Progress',
//     monthlyBreakdown: [],
//   },
//   {
//     id: 'tc2024-009',
//     clientName: 'TechCorp Inc.',
//     contractId: 'TC2024-001',
//     talentName: 'Sarah Johnson',
//     talentId: 'SJ8921',
//     profileImage: '/path/to/image.jpg',
//     pay: {
//       amount: 2300,
//       period: 'month',
//       duration: '12 months',
//     },
//     earned: 9200,
//     pending: 2300,
//     status: 'In Progress',
//     monthlyBreakdown: [],
//   },
//   {
//     id: 'tc2024-0010',
//     clientName: 'TechCorp Inc.',
//     contractId: 'TC2024-001',
//     talentName: 'Sarah Johnson',
//     talentId: 'SJ8921',
//     profileImage: '/path/to/image.jpg',
//     pay: {
//       amount: 2300,
//       period: 'month',
//       duration: '12 months',
//     },
//     earned: 9200,
//     pending: 2300,
//     status: 'In Progress',
//     monthlyBreakdown: [],
//   },
//   {
//     id: 'tc2024-0011',
//     clientName: 'TechCorp Inc.',
//     contractId: 'TC2024-001',
//     talentName: 'Sarah Johnson',
//     talentId: 'SJ8921',
//     profileImage: '/path/to/image.jpg',
//     pay: {
//       amount: 2300,
//       period: 'month',
//       duration: '12 months',
//     },
//     earned: 9200,
//     pending: 2300,
//     status: 'In Progress',
//     monthlyBreakdown: [],
//   },
//   {
//     id: 'tc2024-0012',
//     clientName: 'TechCorp Inc.',
//     contractId: 'TC2024-001',
//     talentName: 'Sarah Johnson',
//     talentId: 'SJ8921',
//     profileImage: '/path/to/image.jpg',
//     pay: {
//       amount: 2300,
//       period: 'month',
//       duration: '12 months',
//     },
//     earned: 9200,
//     pending: 2300,
//     status: 'In Progress',
//     monthlyBreakdown: [],
//   },
//   {
//     id: 'tc2024-0013',
//     clientName: 'TechCorp Inc.',
//     contractId: 'TC2024-001',
//     talentName: 'Sarah Johnson',
//     talentId: 'SJ8921',
//     profileImage: '/path/to/image.jpg',
//     pay: {
//       amount: 2300,
//       period: 'month',
//       duration: '12 months',
//     },
//     earned: 9200,
//     pending: 2300,
//     status: 'In Progress',
//     monthlyBreakdown: [],
//   },
// ];

export const workOffers = [
  {
    id: 1,
    companyName: 'TechCorp Solutions',
    location: 'San Francisco, CA',
    hiringManager: 'Sarah Johnson',
    received: 'September 8, 2025',
    companyLogo: '/agency/offers/techcomp.png',
    status: 'new',
    talents: [
      {
        name: 'David Kumar',
        avatar: '/agency/offers/man.jpg',
        role: 'Senior Developer',
        salary: '$7,200/month',
        duration: '3 months',
        hoursPerDay: '6 hours',
        daysPerWeek: '4 days',
        noticePeriod: '1 week',
        startDate: 'February 5, 2025',
        endDate: 'May 5, 2025',
      },
    ],
  },
  {
    id: 2,
    companyName: 'Zara',
    location: 'San Francisco, CA',
    hiringManager: 'Sarah Johnson',
    received: 'September 7, 2025',
    companyLogo: '/agency/offers/techcomp.png',
    status: 'pending',
    executed: 'February 5, 2025',
    talents: [
      {
        name: 'David Sean',
        avatar: '/agency/offers/man.jpg',
        role: 'Senior Developer',
        salary: '$7,200/month',
        duration: '3 months',
        hoursPerDay: '6 hours',
        daysPerWeek: '4 days',
        noticePeriod: '1 week',
        startDate: 'February 5, 2025',
        endDate: 'May 5, 2025',
      },
      {
        name: 'David Cornsweat',
        avatar: '/agency/offers/man.jpg',
        role: 'Senior Developer',
        salary: '$7,200/month',
        duration: '3 months',
        hoursPerDay: '6 hours',
        daysPerWeek: '4 days',
        noticePeriod: '1 week',
        startDate: 'February 5, 2025',
        endDate: 'May 5, 2025',
      },
    ],
  },
  {
    id: 3,
    companyName: 'TechCorp Solutions',
    location: 'San Francisco, CA',
    hiringManager: 'Sarah Johnson',
    received: 'January 2, 2025',
    companyLogo: '/agency/offers/techcomp.png',
    status: 'active',
    executed: 'February 7, 2025',
    talents: [
      {
        name: 'David Kumar',
        avatar: '/agency/offers/man.jpg',
        role: 'Senior Developer',
        salary: '$7,200/month',
        duration: '3 months',
        hoursPerDay: '6 hours',
        daysPerWeek: '4 days',
        noticePeriod: '1 week',
        startDate: 'February 5, 2025',
        endDate: 'May 5, 2025',
      },
      {
        name: 'David Raj',
        avatar: '/agency/offers/man.jpg',
        role: 'Senior Developer',
        salary: '$7,200/month',
        duration: '3 months',
        hoursPerDay: '6 hours',
        daysPerWeek: '4 days',
        noticePeriod: '1 week',
        startDate: 'February 5, 2025',
        endDate: 'May 5, 2025',
      },
    ],
  },
  {
    id: 4,
    companyName: 'Raise Talks',
    location: 'San Francisco, CA',
    hiringManager: 'Sarah Johnson',
    received: 'January 18, 2025',
    companyLogo: '/agency/offers/techcomp.png',
    status: 'expired',
    expired: 'March 11, 2025',
    talents: [
      {
        name: 'David Kumar',
        avatar: '/agency/offers/man.jpg',
        role: 'Senior Developer',
        salary: '$7,200/month',
        duration: '3 months',
        hoursPerDay: '6 hours',
        daysPerWeek: '4 days',
        noticePeriod: '1 week',
        startDate: 'February 5, 2025',
        endDate: 'May 5, 2025',
      },
    ],
  },
  {
    id: 5,
    companyName: 'HexCorp Solutions',
    location: 'San Francisco, CA',
    hiringManager: 'Sarah Johnson',
    received: 'January 24, 2025',
    companyLogo: '/agency/offers/techcomp.png',
    status: 'completed',
    executed: 'February 10, 2025',
    talents: [
      {
        name: 'David Kumar',
        avatar: '/agency/offers/man.jpg',
        role: 'Senior Developer',
        salary: '$7,200/month',
        duration: '3 months',
        hoursPerDay: '6 hours',
        daysPerWeek: '4 days',
        noticePeriod: '1 week',
        startDate: 'February 5, 2025',
        endDate: 'May 5, 2025',
      },
    ],
  },
  {
    id: 6,
    companyName: 'Elevate',
    location: 'San Francisco, CA',
    hiringManager: 'Sarah Johnson',
    received: 'February 12, 2025',
    companyLogo: '/agency/offers/techcomp.png',
    status: 'rejected',
    rejected: 'March 5, 2025',
    talents: [
      {
        name: 'David Kumar',
        avatar: '/agency/offers/man.jpg',
        role: 'Senior Developer',
        salary: '$7,200/month',
        duration: '3 months',
        hoursPerDay: '6 hours',
        daysPerWeek: '4 days',
        noticePeriod: '1 week',
        startDate: 'February 5, 2025',
        endDate: 'May 5, 2025',
      },
    ],
  },
  {
    id: 7,
    companyName: 'Jane Solutions',
    location: 'San Francisco, CA',
    hiringManager: 'Sarah Johnson',
    received: 'March 28, 2025',
    companyLogo: '/agency/offers/techcomp.png',
    status: 'rejected',
    rejected: 'March 5, 2025',
    talents: [
      {
        name: 'David Kumar',
        avatar: '/agency/offers/man.jpg',
        role: 'Senior Developer',
        salary: '$7,200/month',
        duration: '3 months',
        hoursPerDay: '6 hours',
        daysPerWeek: '4 days',
        noticePeriod: '1 week',
        startDate: 'February 5, 2025',
        endDate: 'May 5, 2025',
      },
    ],
  },
  {
    id: 8,
    companyName: 'Alter Solutions',
    location: 'San Francisco, CA',
    hiringManager: 'Sarah Johnson',
    received: 'February 14, 2025',
    companyLogo: '/agency/offers/techcomp.png',
    status: 'rejected',
    rejected: 'March 5, 2025',
    talents: [
      {
        name: 'David Kumar',
        avatar: '/agency/offers/man.jpg',
        role: 'Senior Developer',
        salary: '$7,200/month',
        duration: '3 months',
        hoursPerDay: '6 hours',
        daysPerWeek: '4 days',
        noticePeriod: '1 week',
        startDate: 'February 5, 2025',
        endDate: 'May 5, 2025',
      },
    ],
  },
  {
    id: 9,
    companyName: 'Argo',
    location: 'San Francisco, CA',
    hiringManager: 'Sarah Johnson',
    received: 'February 12, 2025',
    companyLogo: '/agency/offers/techcomp.png',
    status: 'rejected',
    rejected: 'March 5, 2025',
    talents: [
      {
        name: 'David Kumar',
        avatar: '/agency/offers/man.jpg',
        role: 'Senior Developer',
        salary: '$7,200/month',
        duration: '3 months',
        hoursPerDay: '6 hours',
        daysPerWeek: '4 days',
        noticePeriod: '1 week',
        startDate: 'February 5, 2025',
        endDate: 'May 5, 2025',
      },
    ],
  },
  {
    id: 10,
    companyName: 'Televate',
    location: 'San Francisco, CA',
    hiringManager: 'Sarah Johnson',
    received: 'February 12, 2025',
    companyLogo: '/agency/offers/techcomp.png',
    status: 'rejected',
    rejected: 'March 5, 2025',
    talents: [
      {
        name: 'David Kumar',
        avatar: '/agency/offers/man.jpg',
        role: 'Senior Developer',
        salary: '$7,200/month',
        duration: '3 months',
        hoursPerDay: '6 hours',
        daysPerWeek: '4 days',
        noticePeriod: '1 week',
        startDate: 'February 5, 2025',
        endDate: 'May 5, 2025',
      },
    ],
  },
];

export const tabsItems = [
  'Profile',
  // 'Users',
  // 'Payments',
  // 'Authorized Signatory',
  // 'Security',
  // 'General',
];

export const reviewsMetricsData: {
  title: string;
  change: {
    value: null | string;
    type: string;
  } | null;
  status: null | {
    type: string;
    value: string | null;
  };
  value: string;
  type: string;
  subtitle: string;
}[] = [
  {
    title: 'Average Rating',
    change: null,
    status: null,
    value: '0',
    type: 'rating',
    subtitle: 'Out of 5 stars',
  },
  {
    title: 'Total Reviews',
    change: null,
    status: null,
    value: '0',
    type: 'totalReviews',
    subtitle: 'Total feedback received',
  },
  {
    title: 'Pending Reviews',
    change: null,
    status: null,
    value: '0',
    type: 'pendingReviews',
    subtitle: 'Awaiting your feedback',
  },
];

// export const reviewsMetricsData = [
//   {
//     title: 'Active Contracts',
//     change: {
//       value: '+0.2',
//       type: 'increase',
//     },
//     status: null,
//     value: '4.5',
//     type: 'rating',
//     subtitle: 'Out of 5 stars',
//   },
//   {
//     title: 'Total Reviews',
//     change: {
//       value: '+12',
//       type: 'increase',
//     },
//     status: null,
//     value: '120',
//     type: 'totalReviews',
//     subtitle: 'Total feedback received',
//   },
//   {
//     title: 'Pending Reviews',
//     change: null,
//     status: {
//       type: 'warning',
//       value: '5',
//     },
//     value: '5',
//     type: 'pendingReviews',
//     subtitle: 'Awaiting your feedback',
//   },
// ];

export const contractReviews: {
  clientInfo: {
    avatar: string;
    name: string;
    reviewDate: string;
    contractNo: string;
  };
  talentInfo: {
    avatar: string;
    name: string;
    talentRole: string;
    id: string;
  };
  contractInfo: {
    duration: string;
    dayPerMonth: string;
    hrsPerDay: string;
    contractId: string;
    contractStartDate: string;
  };
  ratingInfo: {
    completion: string;
    onTime: string;
    workEthic: string;
  };
  overallRating: string;
  reviewComment: string;
  clientVisible: boolean;
}[] = [];

// export const contractReviews = [
//   {
//     clientInfo: {
//       avatar: '/agency/reviews/clientPic.png',
//       name: 'John Smith',
//       reviewDate: 'Dec 15, 2023',
//       contractNo: '12345',
//     },
//     talentInfo: {
//       avatar: '/agency/reviews/talentPic.png',
//       name: 'Sarah Wilson',
//       talentRole: 'Developer',
//       id: 'SW001',
//     },
//     contractInfo: {
//       duration: '12',
//       dayPerMonth: '20',
//       hrsPerDay: '7',
//       contractId: '98765X12345',
//       contractStartDate: 'July 15',
//     },
//     ratingInfo: {
//       completion: '5',
//       onTime: '4.3',
//       workEthic: '4',
//     },
//     overallRating: '4.8',
//     reviewComment:
//       'Sarah delivered exceptional work on our brand identity project. Her attention to detail and creative vision exceeded our expectations. The designs were delivered on time and reflected a deep understanding of our goals. Communication throughout the project was smooth and proactive, with Sarah always available to address feedback and suggest improvements. Overall, her contributions added significant value and we look forward to collaborating again in future engagements.',
//     clientVisible: true,
//   },
//   {
//     clientInfo: {
//       avatar: '/agency/reviews/clientPic.png',
//       name: 'Michael Chen',
//       reviewDate: 'Dec 12, 2023',
//       contractNo: '12344',
//     },
//     talentInfo: {
//       avatar: '/agency/reviews/talentPic.png',
//       name: 'David Rodriguez',
//       talentRole: 'Developer',
//       id: 'DR002',
//     },
//     contractInfo: {
//       duration: '12',
//       dayPerMonth: '20',
//       hrsPerDay: '7',
//       contractId: '24680Y67890',
//       contractStartDate: 'Aug 03',
//     },
//     ratingInfo: {
//       completion: '4.1',
//       onTime: '4.8',
//       workEthic: '4.2',
//     },
//     overallRating: '4.3',
//     reviewComment:
//       'Good work overall, but there were some minor delays in the final delivery. The quality of code was excellent and met all requirements. Would recommend for future projects.',
//     clientVisible: false,
//   },
//   {
//     clientInfo: {
//       avatar: '/agency/reviews/clientPic.png',
//       name: 'Emily Carter',
//       reviewDate: 'Jan 10, 2024',
//       contractNo: '12346',
//     },
//     talentInfo: {
//       avatar: '/agency/reviews/talentPic.png',
//       name: 'Liam Patel',
//       talentRole: 'UI/UX Designer',
//       id: 'LP003',
//     },
//     contractInfo: {
//       duration: '6',
//       dayPerMonth: '18',
//       hrsPerDay: '6',
//       contractId: '36452B89012',
//       contractStartDate: 'Jan 05',
//     },
//     ratingInfo: {
//       completion: '4.7',
//       onTime: '4.9',
//       workEthic: '4.8',
//     },
//     overallRating: '4.8',
//     reviewComment:
//       'Liam’s creativity and structured process improved our app’s usability significantly.',
//     clientVisible: true,
//   },
//   {
//     clientInfo: {
//       avatar: '/agency/reviews/clientPic.png',
//       name: 'Sophia Nguyen',
//       reviewDate: 'Feb 20, 2024',
//       contractNo: '12347',
//     },
//     talentInfo: {
//       avatar: '/agency/reviews/talentPic.png',
//       name: 'Marcus Lee',
//       talentRole: 'Frontend Developer',
//       id: 'ML004',
//     },
//     contractInfo: {
//       duration: '9',
//       dayPerMonth: '22',
//       hrsPerDay: '8',
//       contractId: '45783K56320',
//       contractStartDate: 'Feb 01',
//     },
//     ratingInfo: {
//       completion: '4.5',
//       onTime: '4.4',
//       workEthic: '4.7',
//     },
//     overallRating: '4.6',
//     reviewComment:
//       'Marcus built clean and responsive interfaces and always maintained great communication.',
//     clientVisible: true,
//   },
//   {
//     clientInfo: {
//       avatar: '/agency/reviews/clientPic.png',
//       name: 'Rajesh Kumar',
//       reviewDate: 'Mar 05, 2024',
//       contractNo: '12348',
//     },
//     talentInfo: {
//       avatar: '/agency/reviews/talentPic.png',
//       name: 'Olivia Perez',
//       talentRole: 'Product Manager',
//       id: 'OP005',
//     },
//     contractInfo: {
//       duration: '10',
//       dayPerMonth: '21',
//       hrsPerDay: '7',
//       contractId: '58192Z45216',
//       contractStartDate: 'Mar 01',
//     },
//     ratingInfo: {
//       completion: '4.8',
//       onTime: '4.9',
//       workEthic: '5',
//     },
//     overallRating: '4.9',
//     reviewComment:
//       'Olivia organized deliverables seamlessly and provided clarity throughout our milestones.',
//     clientVisible: true,
//   },
//   {
//     clientInfo: {
//       avatar: '/agency/reviews/clientPic.png',
//       name: 'Carlos Mendoza',
//       reviewDate: 'Apr 18, 2024',
//       contractNo: '12349',
//     },
//     talentInfo: {
//       avatar: '/agency/reviews/talentPic.png',
//       name: 'Ethan Brooks',
//       talentRole: 'Backend Developer',
//       id: 'EB006',
//     },
//     contractInfo: {
//       duration: '8',
//       dayPerMonth: '20',
//       hrsPerDay: '8',
//       contractId: '67235T92341',
//       contractStartDate: 'Apr 10',
//     },
//     ratingInfo: {
//       completion: '4.6',
//       onTime: '4.2',
//       workEthic: '4.5',
//     },
//     overallRating: '4.4',
//     reviewComment:
//       'Ethan ensured API performance and stability were top-notch throughout the build.',
//     clientVisible: false,
//   },
//   {
//     clientInfo: {
//       avatar: '/agency/reviews/clientPic.png',
//       name: 'Helen Foster',
//       reviewDate: 'May 28, 2024',
//       contractNo: '12350',
//     },
//     talentInfo: {
//       avatar: '/agency/reviews/talentPic.png',
//       name: 'Nina Sharma',
//       talentRole: 'QA Engineer',
//       id: 'NS007',
//     },
//     contractInfo: {
//       duration: '7',
//       dayPerMonth: '19',
//       hrsPerDay: '6',
//       contractId: '87524P65433',
//       contractStartDate: 'May 10',
//     },
//     ratingInfo: {
//       completion: '5',
//       onTime: '4.9',
//       workEthic: '4.8',
//     },
//     overallRating: '4.9',
//     reviewComment:
//       'Nina’s testing process was detailed and helped us launch a stable product with confidence.',
//     clientVisible: true,
//   },
//   {
//     clientInfo: {
//       avatar: '/agency/reviews/clientPic.png',
//       name: 'Brandon Lewis',
//       reviewDate: 'June 21, 2024',
//       contractNo: '12351',
//     },
//     talentInfo: {
//       avatar: '/agency/reviews/talentPic.png',
//       name: 'Ava Martinez',
//       talentRole: 'Content Strategist',
//       id: 'AM008',
//     },
//     contractInfo: {
//       duration: '5',
//       dayPerMonth: '16',
//       hrsPerDay: '5',
//       contractId: '94177Q56219',
//       contractStartDate: 'June 10',
//     },
//     ratingInfo: {
//       completion: '4.9',
//       onTime: '4.8',
//       workEthic: '4.9',
//     },
//     overallRating: '4.9',
//     reviewComment:
//       'Ava’s strategic content direction made a huge impact on campaign clarity and conversions.',
//     clientVisible: true,
//   },
//   {
//     clientInfo: {
//       avatar: '/agency/reviews/clientPic.png',
//       name: 'Jason Lee',
//       reviewDate: 'Jul 15, 2024',
//       contractNo: '12352',
//     },
//     talentInfo: {
//       avatar: '/agency/reviews/talentPic.png',
//       name: 'Priya Verma',
//       talentRole: 'Project Coordinator',
//       id: 'PV009',
//     },
//     contractInfo: {
//       duration: '8',
//       dayPerMonth: '22',
//       hrsPerDay: '7',
//       contractId: '52348M77902',
//       contractStartDate: 'Jul 05',
//     },
//     ratingInfo: {
//       completion: '4.7',
//       onTime: '5',
//       workEthic: '4.9',
//     },
//     overallRating: '4.9',
//     reviewComment:
//       'Priya was exceptionally well-organized, ensuring each team task was delivered on time.',
//     clientVisible: true,
//   },
//   {
//     clientInfo: {
//       avatar: '/agency/reviews/clientPic.png',
//       name: 'Anna Roberts',
//       reviewDate: 'Aug 10, 2024',
//       contractNo: '12353',
//     },
//     talentInfo: {
//       avatar: '/agency/reviews/talentPic.png',
//       name: 'Thomas Brown',
//       talentRole: 'Data Analyst',
//       id: 'TB010',
//     },
//     contractInfo: {
//       duration: '6',
//       dayPerMonth: '18',
//       hrsPerDay: '6',
//       contractId: '60492J34177',
//       contractStartDate: 'Aug 01',
//     },
//     ratingInfo: {
//       completion: '4.8',
//       onTime: '4.6',
//       workEthic: '4.8',
//     },
//     overallRating: '4.7',
//     reviewComment:
//       'Thomas’s insights from data visualization helped us make more informed marketing decisions.',
//     clientVisible: false,
//   },
//   {
//     clientInfo: {
//       avatar: '/agency/reviews/clientPic.png',
//       name: 'Daniel Cooper',
//       reviewDate: 'Sep 14, 2024',
//       contractNo: '12354',
//     },
//     talentInfo: {
//       avatar: '/agency/reviews/talentPic.png',
//       name: 'Isabella Gomez',
//       talentRole: 'Graphic Designer',
//       id: 'IG011',
//     },
//     contractInfo: {
//       duration: '9',
//       dayPerMonth: '20',
//       hrsPerDay: '6',
//       contractId: '35418U56782',
//       contractStartDate: 'Sep 01',
//     },
//     ratingInfo: {
//       completion: '4.5',
//       onTime: '4.4',
//       workEthic: '4.6',
//     },
//     overallRating: '4.5',
//     reviewComment:
//       'Isabella’s designs captured our vision perfectly. She provided multiple creative options and accepted feedback very professionally.',
//     clientVisible: true,
//   },
//   {
//     clientInfo: {
//       avatar: '/agency/reviews/clientPic.png',
//       name: 'Laura Bennett',
//       reviewDate: 'Oct 02, 2024',
//       contractNo: '12355',
//     },
//     talentInfo: {
//       avatar: '/agency/reviews/talentPic.png',
//       name: 'Jason Park',
//       talentRole: 'Mobile Developer',
//       id: 'JP012',
//     },
//     contractInfo: {
//       duration: '6',
//       dayPerMonth: '21',
//       hrsPerDay: '7',
//       contractId: '41786B95426',
//       contractStartDate: 'Sep 20',
//     },
//     ratingInfo: {
//       completion: '3.9',
//       onTime: '3.8',
//       workEthic: '4',
//     },
//     overallRating: '3.9',
//     reviewComment:
//       'Jason’s coding quality was good, but some sprints required extra time due to debugging sessions.',
//     clientVisible: false,
//   },
//   {
//     clientInfo: {
//       avatar: '/agency/reviews/clientPic.png',
//       name: 'Henry Adams',
//       reviewDate: 'Nov 05, 2024',
//       contractNo: '12356',
//     },
//     talentInfo: {
//       avatar: '/agency/reviews/talentPic.png',
//       name: 'Leah Morgan',
//       talentRole: 'Copywriter',
//       id: 'LM013',
//     },
//     contractInfo: {
//       duration: '4',
//       dayPerMonth: '15',
//       hrsPerDay: '5',
//       contractId: '52977S31250',
//       contractStartDate: 'Oct 22',
//     },
//     ratingInfo: {
//       completion: '5',
//       onTime: '4.9',
//       workEthic: '5',
//     },
//     overallRating: '4.9',
//     reviewComment:
//       'Leah crafted thoughtful, brand-aligned messaging. Her writing improved our web conversions visibly.',
//     clientVisible: true,
//   },
//   {
//     clientInfo: {
//       avatar: '/agency/reviews/clientPic.png',
//       name: 'Chris Evans',
//       reviewDate: 'Dec 11, 2024',
//       contractNo: '12357',
//     },
//     talentInfo: {
//       avatar: '/agency/reviews/talentPic.png',
//       name: 'Victor Lin',
//       talentRole: 'Full Stack Developer',
//       id: 'VL014',
//     },
//     contractInfo: {
//       duration: '12',
//       dayPerMonth: '20',
//       hrsPerDay: '8',
//       contractId: '87331V65120',
//       contractStartDate: 'Nov 30',
//     },
//     ratingInfo: {
//       completion: '4.2',
//       onTime: '3.9',
//       workEthic: '4.3',
//     },
//     overallRating: '4.1',
//     reviewComment:
//       'Victor’s technical expertise was outstanding, though project timelines slipped slightly. Still, the final output was robust and well-tested.',
//     clientVisible: true,
//   },
//   {
//     clientInfo: {
//       avatar: '/agency/reviews/clientPic.png',
//       name: 'Samantha Green',
//       reviewDate: 'Jan 05, 2025',
//       contractNo: '12358',
//     },
//     talentInfo: {
//       avatar: '/agency/reviews/talentPic.png',
//       name: 'Omar Khalid',
//       talentRole: 'SEO Specialist',
//       id: 'OK015',
//     },
//     contractInfo: {
//       duration: '5',
//       dayPerMonth: '18',
//       hrsPerDay: '6',
//       contractId: '91234Q75921',
//       contractStartDate: 'Dec 18',
//     },
//     ratingInfo: {
//       completion: '4.9',
//       onTime: '4.8',
//       workEthic: '4.9',
//     },
//     overallRating: '4.9',
//     reviewComment:
//       'Omar significantly boosted our organic traffic within two months, demonstrating strong analytical and keyword planning skills.',
//     clientVisible: true,
//   },
//   {
//     clientInfo: {
//       avatar: '/agency/reviews/clientPic.png',
//       name: 'Andrew White',
//       reviewDate: 'Feb 08, 2025',
//       contractNo: '12359',
//     },
//     talentInfo: {
//       avatar: '/agency/reviews/talentPic.png',
//       name: 'Sophia Park',
//       talentRole: 'Video Editor',
//       id: 'SP016',
//     },
//     contractInfo: {
//       duration: '3',
//       dayPerMonth: '16',
//       hrsPerDay: '5',
//       contractId: '34521D54098',
//       contractStartDate: 'Jan 15',
//     },
//     ratingInfo: {
//       completion: '4.7',
//       onTime: '5',
//       workEthic: '4.6',
//     },
//     overallRating: '4.8',
//     reviewComment:
//       'Sophia edited promotional videos with an excellent creative touch. She delivered earlier than expected and exceeded our expectations.',
//     clientVisible: true,
//   },
//   {
//     clientInfo: {
//       avatar: '/agency/reviews/clientPic.png',
//       name: 'Robert Miles',
//       reviewDate: 'Mar 09, 2025',
//       contractNo: '12360',
//     },
//     talentInfo: {
//       avatar: '/agency/reviews/talentPic.png',
//       name: 'Elena Rossi',
//       talentRole: 'Marketing Analyst',
//       id: 'ER017',
//     },
//     contractInfo: {
//       duration: '7',
//       dayPerMonth: '20',
//       hrsPerDay: '7',
//       contractId: '59822A98211',
//       contractStartDate: 'Feb 25',
//     },
//     ratingInfo: {
//       completion: '4.3',
//       onTime: '4.5',
//       workEthic: '4.4',
//     },
//     overallRating: '4.4',
//     reviewComment:
//       'Elena provided accurate data insights and marketing recommendations that supported several strategic decisions in Q1.',
//     clientVisible: false,
//   },
// ];

export const activeClients = [];

// export const activeClients = [
//   {
//     profilePic: '/agency/clients/client.png',
//     name: 'Amazon USA',
//     activeSince: 'March 2023',
//     totalEarned: '45,280',
//     pending: '8,500',
//     talentInfo: {
//       avatar: '/agency/reviews/talentPic.png',
//       name: 'Sarah Wilson',
//       talentRole: 'Talent',
//       id: 'SW001',
//     },
//     otherTalents: [
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//     ],
//   },
//   {
//     profilePic: '/agency/clients/client.png',
//     name: 'Atlassian AU',
//     activeSince: 'March 2019',
//     totalEarned: '25,280',
//     pending: '1,700',
//     talentInfo: {
//       avatar: '/agency/reviews/talentPic.png',
//       name: 'Grant Thompson',
//       talentRole: 'Talent',
//       id: 'GT001',
//     },
//     otherTalents: [
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//     ],
//   },
//   {
//     profilePic: '/agency/clients/client.png',
//     name: 'Microsoft UK',
//     activeSince: 'January 2021',
//     totalEarned: '67,450',
//     pending: '12,300',
//     talentInfo: {
//       avatar: '/agency/reviews/talentPic.png',
//       name: 'James Mitchell',
//       talentRole: 'Talent',
//       id: 'JM002',
//     },
//     otherTalents: [
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//     ],
//   },
//   {
//     profilePic: '/agency/clients/client.png',
//     name: 'Salesforce Inc',
//     activeSince: 'July 2020',
//     totalEarned: '89,120',
//     pending: '15,600',
//     talentInfo: {
//       avatar: '/agency/reviews/talentPic.png',
//       name: 'Emily Rodriguez',
//       talentRole: 'Talent',
//       id: 'ER003',
//     },
//     otherTalents: [
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//     ],
//   },
//   {
//     profilePic: '/agency/clients/client.png',
//     name: 'Adobe Systems',
//     activeSince: 'September 2022',
//     totalEarned: '34,890',
//     pending: '5,200',
//     talentInfo: {
//       avatar: '/agency/reviews/talentPic.png',
//       name: 'David Chen',
//       talentRole: 'Talent',
//       id: 'DC004',
//     },
//     otherTalents: [
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//     ],
//   },
//   {
//     profilePic: '/agency/clients/client.png',
//     name: 'Oracle Corp',
//     activeSince: 'February 2018',
//     totalEarned: '102,340',
//     pending: '18,900',
//     talentInfo: {
//       avatar: '/agency/reviews/talentPic.png',
//       name: 'Lisa Anderson',
//       talentRole: 'Talent',
//       id: 'LA005',
//     },
//     otherTalents: [
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//     ],
//   },
//   {
//     profilePic: '/agency/clients/client.png',
//     name: 'Tesla Motors',
//     activeSince: 'November 2021',
//     totalEarned: '56,780',
//     pending: '9,400',
//     talentInfo: {
//       avatar: '/agency/reviews/talentPic.png',
//       name: 'Michael Park',
//       talentRole: 'Talent',
//       id: 'MP006',
//     },
//     otherTalents: [
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//     ],
//   },
//   {
//     profilePic: '/agency/clients/client.png',
//     name: 'Spotify AB',
//     activeSince: 'April 2020',
//     totalEarned: '41,560',
//     pending: '6,800',
//     talentInfo: {
//       avatar: '/agency/reviews/talentPic.png',
//       name: 'Sophia Martinez',
//       talentRole: 'Talent',
//       id: 'SM007',
//     },
//     otherTalents: [
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//     ],
//   },
//   {
//     profilePic: '/agency/clients/client.png',
//     name: 'Netflix Global',
//     activeSince: 'August 2019',
//     totalEarned: '78,920',
//     pending: '14,100',
//     talentInfo: {
//       avatar: '/agency/reviews/talentPic.png',
//       name: 'Robert Kumar',
//       talentRole: 'Talent',
//       id: 'RK008',
//     },
//     otherTalents: [
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//     ],
//   },
//   {
//     profilePic: '/agency/clients/client.png',
//     name: 'Shopify Canada',
//     activeSince: 'May 2022',
//     totalEarned: '29,340',
//     pending: '4,500',
//     talentInfo: {
//       avatar: '/agency/reviews/talentPic.png',
//       name: 'Rachel Greene',
//       talentRole: 'Talent',
//       id: 'RG009',
//     },
//     otherTalents: [
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//     ],
//   },
//   {
//     profilePic: '/agency/clients/client.png',
//     name: 'Zoom Video',
//     activeSince: 'December 2020',
//     totalEarned: '52,670',
//     pending: '8,900',
//     talentInfo: {
//       avatar: '/agency/reviews/talentPic.png',
//       name: 'Kevin Walsh',
//       talentRole: 'Talent',
//       id: 'KW010',
//     },
//     otherTalents: [
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//     ],
//   },
//   {
//     profilePic: '/agency/clients/client.png',
//     name: 'Slack Tech',
//     activeSince: 'June 2021',
//     totalEarned: '38,450',
//     pending: '6,200',
//     talentInfo: {
//       avatar: '/agency/reviews/talentPic.png',
//       name: 'Amanda Foster',
//       talentRole: 'Talent',
//       id: 'AF011',
//     },
//     otherTalents: [
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//     ],
//   },
//   {
//     profilePic: '/agency/clients/client.png',
//     name: 'Dropbox Inc',
//     activeSince: 'October 2019',
//     totalEarned: '61,890',
//     pending: '11,300',
//     talentInfo: {
//       avatar: '/agency/reviews/talentPic.png',
//       name: 'Chris Bennett',
//       talentRole: 'Talent',
//       id: 'CB012',
//     },
//     otherTalents: [
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//     ],
//   },
//   {
//     profilePic: '/agency/clients/client.png',
//     name: 'Figma Design',
//     activeSince: 'March 2022',
//     totalEarned: '27,560',
//     pending: '3,900',
//     talentInfo: {
//       avatar: '/agency/reviews/talentPic.png',
//       name: 'Nina Patel',
//       talentRole: 'Talent',
//       id: 'NP013',
//     },
//     otherTalents: [
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//     ],
//   },
//   {
//     profilePic: '/agency/clients/client.png',
//     name: 'HubSpot Ltd',
//     activeSince: 'January 2020',
//     totalEarned: '73,240',
//     pending: '13,700',
//     talentInfo: {
//       avatar: '/agency/reviews/talentPic.png',
//       name: 'Daniel Harper',
//       talentRole: 'Talent',
//       id: 'DH014',
//     },
//     otherTalents: [
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//     ],
//   },
// ];

export const pastClients = [];

// export const pastClients = [
//   {
//     profilePic: '/agency/clients/client.png',
//     name: 'Airbnb Global',
//     workedSince: 'April 2018',
//     totalEarned: '95,670',
//     talentInfo: {
//       avatar: '/agency/reviews/talentPic.png',
//       name: 'Marcus Lee',
//       talentRole: 'Talent',
//       id: 'ML015',
//     },
//     otherTalents: [
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//     ],
//   },
//   {
//     profilePic: '/agency/clients/client.png',
//     name: 'Uber Tech',
//     workedSince: 'December 2017',
//     totalEarned: '87,430',
//     talentInfo: {
//       avatar: '/agency/reviews/talentPic.png',
//       name: 'Jennifer Moore',
//       talentRole: 'Talent',
//       id: 'JM016',
//     },
//     otherTalents: [
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//     ],
//   },
//   {
//     profilePic: '/agency/clients/client.png',
//     name: 'Pinterest Inc',
//     workedSince: 'June 2019',
//     totalEarned: '43,210',
//     talentInfo: {
//       avatar: '/agency/reviews/talentPic.png',
//       name: 'Tyler Jackson',
//       talentRole: 'Talent',
//       id: 'TJ017',
//     },
//     otherTalents: [
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//     ],
//   },
//   {
//     profilePic: '/agency/clients/client.png',
//     name: 'Stripe Payments',
//     workedSince: 'September 2018',
//     totalEarned: '76,890',
//     talentInfo: {
//       avatar: '/agency/reviews/talentPic.png',
//       name: 'Hannah Davis',
//       talentRole: 'Talent',
//       id: 'HD018',
//     },
//     otherTalents: [
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//     ],
//   },
//   {
//     profilePic: '/agency/clients/client.png',
//     name: 'Twitch Interactive',
//     workedSince: 'February 2020',
//     totalEarned: '54,320',
//     talentInfo: {
//       avatar: '/agency/reviews/talentPic.png',
//       name: 'Brandon White',
//       talentRole: 'Talent',
//       id: 'BW019',
//     },
//     otherTalents: [
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//     ],
//   },
//   {
//     profilePic: '/agency/clients/client.png',
//     name: 'Notion Labs',
//     workedSince: 'May 2021',
//     totalEarned: '38,760',
//     talentInfo: {
//       avatar: '/agency/reviews/talentPic.png',
//       name: 'Olivia Harris',
//       talentRole: 'Talent',
//       id: 'OH020',
//     },
//     otherTalents: [
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//     ],
//   },
//   {
//     profilePic: '/agency/clients/client.png',
//     name: 'Discord Services',
//     workedSince: 'August 2019',
//     totalEarned: '62,540',
//     talentInfo: {
//       avatar: '/agency/reviews/talentPic.png',
//       name: 'Ethan Martinez',
//       talentRole: 'Talent',
//       id: 'EM021',
//     },
//     otherTalents: [
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//     ],
//   },
//   {
//     profilePic: '/agency/clients/client.png',
//     name: 'Canva Design',
//     workedSince: 'November 2020',
//     totalEarned: '49,880',
//     talentInfo: {
//       avatar: '/agency/reviews/talentPic.png',
//       name: 'Isabella Clark',
//       talentRole: 'Talent',
//       id: 'IC022',
//     },
//     otherTalents: [
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//     ],
//   },
//   {
//     profilePic: '/agency/clients/client.png',
//     name: 'Asana Inc',
//     workedSince: 'March 2018',
//     totalEarned: '71,230',
//     talentInfo: {
//       avatar: '/agency/reviews/talentPic.png',
//       name: 'Matthew Turner',
//       talentRole: 'Talent',
//       id: 'MT023',
//     },
//     otherTalents: [
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//     ],
//   },
//   {
//     profilePic: '/agency/clients/client.png',
//     name: 'Atlassian Corp',
//     workedSince: 'July 2019',
//     totalEarned: '84,560',
//     talentInfo: {
//       avatar: '/agency/reviews/talentPic.png',
//       name: 'Mia Rodriguez',
//       talentRole: 'Talent',
//       id: 'MR024',
//     },
//     otherTalents: [
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//     ],
//   },
//   {
//     profilePic: '/agency/clients/client.png',
//     name: 'GitLab Inc',
//     workedSince: 'January 2021',
//     totalEarned: '58,920',
//     talentInfo: {
//       avatar: '/agency/reviews/talentPic.png',
//       name: 'Jacob Wilson',
//       talentRole: 'Talent',
//       id: 'JW025',
//     },
//     otherTalents: [
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//     ],
//   },
//   {
//     profilePic: '/agency/clients/client.png',
//     name: 'Zendesk Ltd',
//     workedSince: 'October 2018',
//     totalEarned: '66,340',
//     talentInfo: {
//       avatar: '/agency/reviews/talentPic.png',
//       name: 'Ava Thompson',
//       talentRole: 'Talent',
//       id: 'AT026',
//     },
//     otherTalents: [
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//     ],
//   },
//   {
//     profilePic: '/agency/clients/client.png',
//     name: 'Mailchimp Inc',
//     workedSince: 'April 2020',
//     totalEarned: '45,670',
//     talentInfo: {
//       avatar: '/agency/reviews/talentPic.png',
//       name: 'William Garcia',
//       talentRole: 'Talent',
//       id: 'WG027',
//     },
//     otherTalents: [
//       '/agency/clients/talent2.jpg',
//       '/agency/clients/talent3.jpg',
//       '/agency/clients/talent2.jpg',
//     ],
//   },
// ];

export const contractData = {
  clientName: 'TechCorp Solutions',
  ticketId: '#TMN7851',
  status: 'In Progress',
  timeAgo: '1 week ago',
  talent: {
    name: 'Oliver Herry',
    role: 'Senior UI/UX Designer',
    avatar:
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face',
    rate: '$4,500 / Month',
    ticketId: '#TMN7851',
  },
  associate: {
    name: 'Alex Johnson',
    role: 'Project Manager',
  },
  contract: {
    startDate: 'Jul 15, 2024',
    contractNumber: '#BI-2024-003',
    duration: '6 months',
    daysPerMonth: '21 days/month',
    hoursPerDay: '8 hrs/day',
    totalMonths: 6,
    completedMonths: 2,
    progress: 33, // 2 of 6 months = 33%
    completed: '2 of 6 months completed',
    endDate: 'Jan 15, 2025',
  },
  approvalStats: {
    workingDays: 8,
    approved: 6,
    yetToApprove: 2,
    total: 8,
  },
};

export const weeklyData = {
  weekNumber: 3,
  days: [
    { day: 'Monday', date: 1, status: 'approved', hours: 8 },
    { day: 'Tuesday', date: 2, status: 'approved', hours: 8 },
    { day: 'Wednesday', date: 3, status: 'rejected', hours: 0 },
    { day: 'Thursday', date: 4, status: 'pending', hours: 8 },
    { day: 'Friday', date: 5, status: 'no-record', hours: 8 },
    { day: 'Saturday', date: 6, status: 'weekend', hours: 0 },
    { day: 'Sunday', date: 7, status: 'weekend', hours: 0 },
  ],
};

export const monthlyData = {
  month: 'October',
  year: 2024,
  days: [
    { date: 1, status: 'approved', day: 'Monday' },
    { date: 2, status: 'approved', day: 'Tuesday' },
    { date: 3, status: 'rejected', day: 'Wednesday' },
    { date: 4, status: 'approved', day: 'Thursday' },
    { date: 5, status: 'approved', day: 'Friday' },
    { date: 6, status: 'weekend', day: 'Saturday' },
    { date: 7, status: 'weekend', day: 'Sunday' },
    { date: 8, status: 'approved', day: 'Monday' },
    { date: 9, status: 'approved', day: 'Tuesday' },
    { date: 10, status: 'approved', day: 'Wednesday' },
    { date: 11, status: 'approved', day: 'Thursday' },
    { date: 12, status: 'rejected', day: 'Friday' },
    { date: 13, status: 'weekend', day: 'Saturday' },
    { date: 14, status: 'weekend', day: 'Sunday' },
    { date: 15, status: 'pending', day: 'Monday' },
    { date: 16, status: 'rejected', day: 'Tuesday' },
    { date: 17, status: 'approved', day: 'Wednesday' },
    { date: 18, status: 'approved', day: 'Thursday' },
    { date: 19, status: 'pending', day: 'Friday' },
    { date: 20, status: 'weekend', day: 'Saturday' },
    { date: 21, status: 'weekend', day: 'Sunday' },
    { date: 22, status: 'approved', day: 'Monday' },
    { date: 23, status: 'approved', day: 'Tuesday' },
    { date: 24, status: 'approved', day: 'Wednesday' },
    { date: 25, status: 'rejected', day: 'Thursday' },
    { date: 26, status: 'no-record', day: 'Friday' },
    { date: 27, status: 'weekend', day: 'Saturday' },
    { date: 28, status: 'weekend', day: 'Sunday' },
  ],
};

export const proficiencyOptions = [
  {
    value: 'ELEMENTARY_PROFICIENCY',
    label: 'Elementary: Simple ideas',
  },
  {
    value: 'LIMITED_WORKING_PROFICIENCY',
    label: 'Limited Working: Day-to-day interactions',
  },
  {
    value: 'PROFESSIONAL_WORKING_PROFICIENCY',
    label: 'Professional Working: Few limitations',
  },
  {
    value: 'FULL_PROFESSIONAL_PROFICIENCY',
    label: 'Full Professional: Near native ability',
  },
  {
    value: 'NATIVE_OR_BILINGUAL_PROFICIENCY',
    label: 'Native/Bilingual: First language mastery',
  },
];

// ================= billingDetails =================

export const BILLING_DETAILS = {
  back: 'Back to Membership',
  title: 'Billing Details',
  subtitle: 'Manage your billing address and tax information',

  sections: {
    billingAddress: 'Billing Address',
    taxInfo: 'Tax Information',
    billingContact: 'Billing Contact',
  },

  fields: {
    companyName: 'Company Name',
    address1: 'Address Line 1',
    address2: 'Address Line 2',
    city: 'City',
    state: 'State/Province',
    zip: 'ZIP/Postal Code',
    country: 'Country',
    taxId: 'Tax ID / VAT Number',
    billingEmail: 'Billing Email',
  },
};

// manage payment method
export const MANAGE_PAYMENT_METHOD = {
  back: 'Back to Membership',
  title: 'Cards',
  subtitle: 'Manage your saved cards',
  addNewCard: 'Add New Card',
  setAsDefault: 'Set as Default',
  remove: 'Remove',
  default: 'Default',
  expires: 'Expires',
  expired: 'Expired',
  endingIn: 'ending in',
};

// Modal constants
export const PAYMENT_METHOD_MODALS = {
  setDefault: {
    title: 'Set as Default Payment Method',
    message: 'Are you sure you want to set',
    messageSuffix: 'as your default payment method?',
    cancelButton: 'Cancel',
    confirmButton: 'Set as Default',
  },
  remove: {
    title: 'Remove Payment Method',
    message: 'Are you sure you want to remove',
    warning: 'This action cannot be undone.',
    cancelButton: 'Cancel',
    confirmButton: 'Remove',
  },
  addCard: {
    title: 'Add New Card',
    placeholder: 'Card form will be implemented here.',
  },
};

// payment.ts contants
const PUBLIC_URL = process.env.PUBLIC_URL || '';
export const CARD_ICONS: Record<string, string> = {
  mastercard: `${PUBLIC_URL}/assets/paymentCards/mastercard.svg`,
  visa: `${PUBLIC_URL}/assets/paymentCards/visa.svg`,
  visacard: `${PUBLIC_URL}/assets/paymentCards/visalogo.png`,
  amex: `${PUBLIC_URL}/assets/paymentCards/amex.svg`,
  amexcard: `${PUBLIC_URL}/assets/paymentCards/amexlogo.png`,
  rupay: `${PUBLIC_URL}/assets/paymentCards/rupay.svg`,
  default: `${PUBLIC_URL}/assets/paymentCards/card.svg`,
};

// ================= Billing Plan (RENAMED) =================

const ALL_PLANS: Record<'Free' | 'Basic' | 'Standard', BillingPlan> = {
  Free: {
    name: 'Free Plan',
    memberSince: 'January 2024',
    price: 0,
    interval: 'month',
    nextPayment: '-/-',
  },
  Basic: {
    name: 'Basic Plan',
    memberSince: 'January 2024',
    price: 49,
    interval: 'month',
    nextPayment: 'February 15, 2024',
    paymentMethod: {
      brand: 'mastercard',
      last4: '8899',
      expiry: '08/27',
    },
  },
  Standard: {
    name: 'Standard Plan',
    memberSince: 'January 2024',
    price: 200,
    interval: 'month',
    nextPayment: 'February 15, 2024',
    paymentMethod: {
      brand: 'mastercard',
      last4: '4242',
      expiry: '12/26',
    },
  },
};

export const planData: BillingPlan = ALL_PLANS.Free;

// ================= Quick Links =================

export const quickLinks = [
  {
    title: 'Change Plan',
    description: 'Review plans. Upgrade or downgrade anytime.',
    icon: RefreshCcw,
    route: '/settings/billing/plans',
  },
  {
    title: 'Billing Details',
    description: 'View and manage billing information.',
    icon: FileText,
    route: '/settings/billing-details',
  },
  {
    title: 'Manage Payment Method',
    description: 'Add, edit or remove payment methods.',
    icon: CreditCard,
    // route: "/settings/billing/methods",
    route: '/settings/manage-payment-method',
  },
  {
    title: 'Payment History',
    description: 'Review past transactions and download invoices.',
    icon: Clock,
    route: '/settings/billing/history',
  },
];

export const CURRENT_PLAN_KEY: PlanKey = 'Basic';

export const plans: PricingPlan[] = [
  {
    key: 'Free',
    title: 'Free',
    price: 0,
    displayPrice: '$0',
    per: '/month',
    description: 'Limited features included',
    features: [
      '1 Workstream',
      'Up to 2 SDRs',
      '5 Associates',
      'Basic project management',
      'Email support',
    ],
  },
  {
    key: 'Basic',
    title: 'Basic',
    price: 100,
    displayPrice: '$100',
    per: '/month',
    features: [
      '3 Workstreams',
      'Up to 5 SDRs',
      '15 Associates',
      'Advanced project tools',
      'Priority support',
      'Basic analytics',
    ],
  },
  {
    key: 'Standard',
    title: 'Standard',
    price: 200,
    displayPrice: '$200',
    per: '/month',
    features: [
      '10 Workstreams',
      'Up to 15 SDRs',
      '50 Associates',
      'Client facing features',
      'Group chat & payments',
      'Advanced analytics',
    ],
    recommended: true,
  },
  {
    key: 'Enterprise',
    title: 'Enterprise',
    price: 0,
    displayPrice: 'Contact Us',
    per: '',
    features: [
      'Unlimited Workstreams',
      'Unlimited SDRs',
      'Unlimited Associates',
      'Custom Integrations',
      'Dedicated support',
      'White-label options',
    ],
  },
];

export interface BillingFormValues {
  companyName: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  taxId: string;
  billingEmail: string;
}

export const fieldsToCheck = [
  'companyName', // 1
  'companyType', // 2
  'corporateId', // 3
  'incDate', // 4
  'regCountry', // 5
  'agAddressDtos', // 6 (Address Block)
  'pryContactEmail', // 7
  // 'phoneNumber', // 8
  'publicName', // 9
  'website', // 10
  'employeesNo', // 11
  'foundedYear', // 12
  'overView', // 13
  'industryServed', //14
  'agencySkills', // 15
  'linkedInUrl', // 16
  'logo', // 17
];
